import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ApiConfigEffects } from './api-config.effects';
import { apiConfigFeature } from './api-config.reducer';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(apiConfigFeature), EffectsModule.forFeature([ApiConfigEffects])],
})
export class ApiConfigStateModule {}
